import {
  AlignItems,
  AlignSelf,
  Box,
  Color,
  Display,
  FlexDirection,
  FontFamily,
  JustifyContent,
  Text,
  TextAlign,
  useTheme,
} from '@gousto-internal/citrus-react';
import { PricingDTOTypes } from '@repo/experience-api-client';
import { PriceBlockColumn } from './layout';

const BODY_2_SIZE = 4;

type PriceColumnProps = {
  price: string;
  unit: string;
  comparator: string;
};

function PriceColumn({ price, unit, comparator }: PriceColumnProps): JSX.Element {
  const { theme } = useTheme();
  const headingSize = theme.tokens.typographyDefaults.h2.size;

  return (
    <PriceBlockColumn>
      <Box
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
        alignItems={[AlignItems.Center, null, AlignItems.Baseline]}
        gap={1}
      >
        <Text fontFamily={FontFamily.Bold} size={headingSize} color={Color.ColdGrey_800}>
          {price}
        </Text>
        <Text fontFamily={FontFamily.Bold} size={BODY_2_SIZE} color={Color.ColdGrey_800}>
          {unit}
        </Text>
      </Box>
      <Text
        fontFamily={FontFamily.Book}
        size={BODY_2_SIZE}
        color={Color.ColdGrey_800}
        textAlign={TextAlign.Center}
      >
        {comparator}
      </Text>
    </PriceBlockColumn>
  );
}

type Props = {
  option: PricingDTOTypes.PricingOptionDTO;
};

export function PriceBlock({ option }: Props): JSX.Element {
  return (
    <Box
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      paddingV={4}
      paddingH={3}
      gap={2}
    >
      <PriceColumn
        price={option.firstBoxPricePerBox}
        unit="per box"
        comparator={`Usually ${option.pricePerBox} per box`}
      />
      <Box width="1px" bg={Color.ColdGrey_100} alignSelf={AlignSelf.Stretch} />
      <PriceColumn
        price={option.firstBoxPricePerPortion}
        unit="per portion"
        comparator={`Usually ${option.pricePerPortion} per portion`}
      />
    </Box>
  );
}
